import { useMutation } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { message } from 'antd';

import ResetPasswordForm from 'components/forms/reset-password-form';
import useTranslation from 'customHooks/translate';
import { PasswordResetCustomError } from 'types';

import HeaderSecondary from '../components/Header/headerSecondary';
import { passwordReset } from '../services/auth';

const PasswordReset = () => {
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState<
    string | null
  >(null);

  const translation = useTranslation();
  const navigate = useNavigate();

  const { mutate: passwordResetHandler, isLoading } = useMutation(
    passwordReset,
    {
      onSuccess() {
        message.success(`${translation.messages.successReset}`);
        navigate('/login', { replace: true });
      },

      onError(error: PasswordResetCustomError) {
        const passwordErrorMessage =
          error.response?.data?.errors?.Password?.[0] || null;
        const confirmPasswordErrorMessage =
          error.response?.data?.errors?.ConfirmPassword?.[0] || null;

        const formattedPasswordError = passwordErrorMessage
          ? passwordErrorMessage.charAt(0).toUpperCase() +
            passwordErrorMessage.slice(1)
          : null;
        const formattedConfirmPasswordError = confirmPasswordErrorMessage
          ? confirmPasswordErrorMessage.charAt(0).toUpperCase() +
            confirmPasswordErrorMessage.slice(1)
          : null;

        setPasswordError(formattedPasswordError);
        setConfirmPasswordError(formattedConfirmPasswordError);

        const generalErrorMessage = error.response?.data?.Message?.[0] || null;
        if (generalErrorMessage) {
          message.error(generalErrorMessage);
        }
      },
    }
  );

  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  return token ? (
    <section className="box-border grid h-screen grid-cols-1 gap-[60px] overflow-hidden px-[24px] py-[24px]  md:pr-[24px] lg:grid-cols-2 xl:grid-cols-3 xl:gap-[120px] xl:pl-[156px]">
      <div className="col-span-1 flex flex-col gap-[96px]">
        <HeaderSecondary />
        <div className="flex flex-col gap-[24px]">
          <h1 className="text-4xl font-bold text-[#222]">
            {translation.resetPassword.ResetYourPassword}
          </h1>
          <ResetPasswordForm
            consfirmPasswordError={confirmPasswordError}
            passwordError={passwordError}
            passwordResetHandler={passwordResetHandler}
            token={token}
            isLoading={isLoading}
          />
        </div>
      </div>
      <div className="cols-span-1 hidden h-full overflow-hidden rounded-[24px] lg:block xl:col-span-2">
        <img
          src="assets/login-cover.svg"
          alt="login-cover"
          className="h-full w-full object-cover"
        />
      </div>
    </section>
  ) : null;
};

export default PasswordReset;
